export default __webpack_public_path__ + "static/media/Forest_01.cf58fc35.png";